import { lazy, Suspense, type ComponentProps } from 'react';

// Lazy boundary for the 3D model viewer. ThreeDeeViewer pulls in the 3D stack
// (@react-three/drei + @react-three/fiber + three, ~3.7MB), but it only renders
// for 3D media — a niche case, never on first paint of a typical workflow. It was
// statically imported by several core editor files (node rendering, file uploader,
// gallery), which dragged that stack onto the editor's cold-boot critical path.
// Splitting it into its own chunk loads it only when a 3D model actually renders.
const ThreeDeeViewer = lazy(() => import('./ThreeDeeViewer'));

export default function LazyThreeDeeViewer(props: ComponentProps<typeof ThreeDeeViewer>) {
  return (
    <Suspense fallback={null}>
      <ThreeDeeViewer {...props} />
    </Suspense>
  );
}
